import { useEffect } from "react";

const useBeforeUnload = (isSending: boolean): void => {
  useEffect(() => {
    const isProductions = import.meta.env.PROD;

    if (!isProductions) return;
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (isSending) {
        event.preventDefault();
        event.returnValue = "";
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [isSending]);
};

export default useBeforeUnload;
